import React, { Component } from 'react'
import {
  Table,
  Badge,
  Collapse,
  Row,
  Col,
  Button,
  Modal,
  Input,
  Form,
  Tooltip,
  Icon,
} from 'antd'
import { Formik } from 'formik'
import moment from 'moment'
import LangContext from 'modules/shared/context/langContext'
import { Link, Redirect } from 'react-router-dom'
import LccCauseModal from './LccCauseModal'
import LccCauseDetailModal from './LccCauseDetailModal'
import { isAiCameraEvent } from '../constants/event'

const { Panel } = Collapse
const { TextArea } = Input
const FormItem = Form.Item
const genExtra = value => <h>{value}</h>

const columnsTypeNormal = [
  {
    title: (
      <LangContext.Consumer>
        {i18n => (
          <div style={{ fontSize: '13px' }}>
            <div>{`${i18n.p.plateNo}`}</div>
            <div>{`(${i18n.v.vnCode})`}</div>
          </div>
        )}
      </LangContext.Consumer>
    ),
    dataIndex: 'plate_no',
    className: 'column-text-center',
    key: 'plate_no',
    width: '15%',
    render: (text, record) => (
      <div>
        <div>{text}</div>
        <div style={{ color: '#888', fontSize: '11px' }}>
          {record.vehicleCode}
        </div>
      </div>
    ),
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>{i18n => i18n.p.period}</LangContext.Consumer> (
        <LangContext.Consumer>{i18n => i18n.m.minute}</LangContext.Consumer>)
      </span>
    ),
    className: 'column-text-center',
    dataIndex: 'duration',
    key: 'duration',
    width: '10%',
    render(text, record, index) {
      return {
        children: (
          <div>
            {record.durationMinute}:{text}
          </div>
        ),
      }
    },
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>{i18n => i18n.p.plantName}</LangContext.Consumer>
      </span>
    ),
    dataIndex: 'plantPunchInName',
    className: 'column-text-center',
    key: 'plantPunchInName',
    render: (text, record, index) => {
      return <label>{text == '' ? '-' : text}</label>
    },
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>
          {i18n => i18n.s.siteNameSafetyDashboard}
        </LangContext.Consumer>
      </span>
    ),
    dataIndex: 'siteName',
    className: 'column-text-center',
    key: 'siteName',
    render: (text, record, index) => {
      return <label>{text == '' ? '-' : text}</label>
    },
  },
]

const columnsTypeNormal2 = [
  {
    title: (
      <LangContext.Consumer>
        {i18n => (
          <div style={{ fontSize: '13px' }}>
            <div>{`${i18n.p.plateNo}`}</div>
            <div>{`(${i18n.v.vnCode})`}</div>
          </div>
        )}
      </LangContext.Consumer>
    ),
    dataIndex: 'plate_no',
    className: 'column-text-center',
    key: 'plate_no',
    width: '15%',
    render: (text, record) => (
      <div>
        <div>{text}</div>
        <div style={{ color: '#888', fontSize: '11px' }}>
          {record.vehicleCode}
        </div>
      </div>
    ),
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>{i18n => i18n.p.period}</LangContext.Consumer> (
        <LangContext.Consumer>{i18n => i18n.m.minute}</LangContext.Consumer>)
      </span>
    ),
    className: 'column-text-center',
    dataIndex: 'startAtDate',
    key: 'startAt',
    width: '10%',
    render(text, record, index) {
      return {
        children: (
          <div>
            <div>{text}</div>
            <div style={{ color: '#888', fontSize: '11px' }}>
              {record.startAtTime}
            </div>
          </div>
        ),
      }
    },
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>{i18n => i18n.p.plantName}</LangContext.Consumer>
      </span>
    ),
    dataIndex: 'plantPunchInName',
    className: 'column-text-center',
    key: 'plantPunchInName',
    width: '25%',
    render: text => {
      return <label>{text === '' ? '-' : text}</label>
    },
  },
  {
    title: (
      <span style={{ fontSize: '13px' }}>
        <LangContext.Consumer>
          {i18n => i18n.s.siteNameSafetyDashboard}
        </LangContext.Consumer>
      </span>
    ),
    dataIndex: 'siteName',
    className: 'column-text-center',
    key: 'siteName',
    width: '25%',
    render: text => {
      return <label>{text === '' ? '-' : text}</label>
    },
  },
]

export class ExpandableTable extends Component {
  state = {
    selectedRow: '',
    visibleNote: false,
    visibleNoteSpeedOverlimite: false,
    tempNote: null,
    tempId: null,
    visibleLccCause: false,
    lccRecord: null,
    visibleLccCauseDetail: false,
    lccDetailRecord: null,
    visibleVideoModal: false,
    videoModalUrl: null,
  }

  handleOpenVideoModal = url =>
    this.setState({ visibleVideoModal: true, videoModalUrl: url })

  handleCloseVideoModal = () =>
    this.setState({ visibleVideoModal: false, videoModalUrl: null })

  renderLccCauseCell = (text, record) => {
    const profile =
      this.props.auth && this.props.auth.profile ? this.props.auth.profile : {}
    const isLcc = profile.company_id === 54 ? 1 : 0
    const alreadyRecorded = record.lcc_cause && record.lcc_cause.id !== 0
    const hasPermission = record.is_lcc_enable && isLcc

    if (!hasPermission) return null

    if (alreadyRecorded) {
      return (
        <LangContext.Consumer>
          {i18n => (
            <Tooltip title={i18n.d.detail}>
              <Button
                type="primary"
                size="small"
                icon="file-text"
                onClick={e => {
                  e.stopPropagation()
                  this.handleOpenLccCauseDetail(record)
                }}
              />
            </Tooltip>
          )}
        </LangContext.Consumer>
      )
    }

    if (record.incident_lcc_status === 3) return null

    return (
      <LangContext.Consumer>
        {i18n => (
          <Tooltip title={i18n.r.recordTheReason}>
            <Button
              size="small"
              icon="form"
              onClick={e => {
                e.stopPropagation()
                this.handleOpenLccCause(record)
              }}
            />
          </Tooltip>
        )}
      </LangContext.Consumer>
    )
  }

  columnsTypeAdasDms = [
    {
      title: (
        <LangContext.Consumer>
          {i18n => (
            <div style={{ fontSize: '13px' }}>
              <div>{`${i18n.p.plateNo}`}</div>
              <div>{`(${i18n.v.vnCode})`}</div>
            </div>
          )}
        </LangContext.Consumer>
      ),
      dataIndex: 'plate_no',
      className: 'column-text-center',
      key: 'plate_no',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.vehicleCode}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.d.dateTime}</LangContext.Consumer>
        </span>
      ),
      className: 'column-text-center',
      dataIndex: 'startAtDate',
      key: 'startAt',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.startAtTime}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.t.type}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'alarmType',
      className: 'column-text-center',
      key: 'alarmType',
      width: '20%',
      render: text => (
        <LangContext.Consumer>
          {i18n => <label>{i18n.safetyAlarmType[text] || '-'}</label>}
        </LangContext.Consumer>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.p.plantName}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'plantPunchInName',
      className: 'column-text-center',
      key: 'plantPunchInName',
      render: text => <label>{text === '' ? '-' : text}</label>,
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.s.siteNameSafetyDashboard}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'siteName',
      className: 'column-text-center',
      key: 'siteName',
      render: text => <label>{text === '' ? '-' : text}</label>,
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.v.viewVideo}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'videoUrl',
      className: 'column-text-center',
      key: 'videoUrl',
      width: '10%',
      render: (text, record) =>
        record.videoUrl ? (
          <Button
            shape="circle"
            size="small"
            icon="play-circle"
            onClick={e => {
              e.stopPropagation()
              this.handleOpenVideoModal(record.videoUrl)
            }}
          />
        ) : (
          '-'
        ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.n.note}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'note',
      key: 'note',
      className: 'column-text-center',
      width: '10%',
      render: (text, record) => this.renderLccCauseCell(text, record),
    },
  ]

  columnsTypeDA = [
    {
      title: (
        <LangContext.Consumer>
          {i18n => (
            <div style={{ fontSize: '13px' }}>
              <div>{`${i18n.p.plateNo}`}</div>
              <div>{`(${i18n.v.vnCode})`}</div>
            </div>
          )}
        </LangContext.Consumer>
      ),
      dataIndex: 'plate_no',
      className: 'column-text-center',
      key: 'plate_no',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.vehicleCode}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.d.dateTime}</LangContext.Consumer>
        </span>
      ),
      className: 'column-text-center',
      dataIndex: 'startAtDate',
      key: 'startAt',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.startAtTime}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.t.type}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'alarmType',
      className: 'column-text-center',
      key: 'alarmType',
      width: '20%',
      render: text => (
        <LangContext.Consumer>
          {i18n => <label>{i18n.safetyAlarmType[text] || '-'}</label>}
        </LangContext.Consumer>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.p.plantName}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'plantPunchInName',
      className: 'column-text-center',
      key: 'plantPunchInName',
      render: text => <label>{text === '' ? '-' : text}</label>,
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.s.siteNameSafetyDashboard}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'siteName',
      className: 'column-text-center',
      key: 'siteName',
      render: text => <label>{text === '' ? '-' : text}</label>,
    },
  ]

  handleOpenLccCause = record =>
    this.setState({ visibleLccCause: true, lccRecord: record })

  handleCloseLccCause = () =>
    this.setState({ visibleLccCause: false, lccRecord: null })

  handleSaveLccCause = () => {
    this.setState({ visibleLccCause: false, lccRecord: null })
    if (this.props.onRefresh) this.props.onRefresh()
  }

  handleOpenLccCauseDetail = record =>
    this.setState({ visibleLccCauseDetail: true, lccDetailRecord: record })

  handleCloseLccCauseDetail = () =>
    this.setState({ visibleLccCauseDetail: false, lccDetailRecord: null })
  onRowClick = (id, lat, lng, isParking = false) => {
    this.props.onRowClick(lat, lng, id, isParking)
    this.setState({ selectedRow: id })
  }

  handleSaveNote = () => {
    this.props.onSaveNote({
      note: this.state.tempNote,
      _id: this.state.tempId,
    })
  }

  columnsTypeSpeed = [
    {
      title: (
        <LangContext.Consumer>
          {i18n => (
            <div style={{ fontSize: '13px' }}>
              <div>{`${i18n.p.plateNo}`}</div>
              <div>{`(${i18n.v.vnCode})`}</div>
            </div>
          )}
        </LangContext.Consumer>
      ),
      dataIndex: 'plate_no',
      key: 'plate_no',
      className: 'column-text-center',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.vehicleCode}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.p.period}</LangContext.Consumer> (
          <LangContext.Consumer>{i18n => i18n.m.minute}</LangContext.Consumer>)
        </span>
      ),
      className: 'column-text-center',
      dataIndex: 'duration',
      key: 'duration',
      width: '10%',
      render(text, record, index) {
        return {
          children: (
            <div>
              {record.durationMinute}:{text}
            </div>
          ),
        }
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.dashboard_summary.maxSpeed}
          </LangContext.Consumer>{' '}
          (<LangContext.Consumer>{i18n => i18n.k.kmH}</LangContext.Consumer>)
        </span>
      ),
      width: '10%',
      className: 'column-text-center',
      dataIndex: 'maxSpeed',
      key: 'maxSpeed',
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.t.type}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'type',
      className: 'column-text-center',
      ellipsis: true,
      key: 'type',
      width: '10%',
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.p.plantName}
          </LangContext.Consumer>
        </span>
      ),
      width: '10%',
      dataIndex: 'plantPunchInName',
      className: 'column-text-center',
      key: 'plantPunchInName',
      render: (text, record, index) => {
        return <label>{text == '' ? '-' : text}</label>
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.s.siteNameSafetyDashboard}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'siteName',
      className: 'column-text-center',
      key: 'siteName',
      width: '23%',
      render: (text, record, index) => {
        return <label>{text == '' ? '-' : text}</label>
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.n.note}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'note',
      key: 'note',
      className: 'column-text-center',
      width: '10%',
      render: (text, record, index) => {
        {
          const profile =
            this.props.auth && this.props.auth.profile
              ? this.props.auth.profile
              : {}
          const isLcc = profile.company_id === 54 ? 1 : 0
          const alreadyRecorded = record.lcc_cause && record.lcc_cause.id !== 0
          const hasPermission = record.is_lcc_enable && isLcc

          if (!hasPermission) return null

          if (alreadyRecorded) {
            return (
              <LangContext.Consumer>
                {i18n => (
                  <Tooltip title={i18n.d.detail}>
                    <Button
                      type="primary"
                      size="small"
                      icon="file-text"
                      onClick={e => {
                        e.stopPropagation()
                        this.handleOpenLccCauseDetail(record)
                      }}
                    />
                  </Tooltip>
                )}
              </LangContext.Consumer>
            )
          }

          //   ปิดไม่ให้คอลัมน์ประเภทความเร็วเกินกำหนดสามารถบันทึกสาเหตุได้
          //   if (record.incident_lcc_status === 3) return null

          //   return (
          //     <LangContext.Consumer>
          //       {i18n => (
          //         <Tooltip title={i18n.r.recordTheReason}>
          //           <Button
          //             size="small"
          //             icon="form"
          //             onClick={e => {
          //               e.stopPropagation()
          //               this.handleOpenLccCause(record)
          //             }}
          //           />
          //         </Tooltip>
          //       )}
          //     </LangContext.Consumer>
          //   )
        }
      },
    },
  ]

  columnsTypeNormals = [
    {
      title: (
        <LangContext.Consumer>
          {i18n => (
            <div style={{ fontSize: '13px' }}>
              <div>{`${i18n.p.plateNo}`}</div>
              <div>{`(${i18n.v.vnCode})`}</div>
            </div>
          )}
        </LangContext.Consumer>
      ),
      dataIndex: 'plate_no',
      className: 'column-text-center',
      key: 'plate_no',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.vehicleCode}
          </div>
        </div>
      ),
    },

    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.p.period}</LangContext.Consumer> (
          <LangContext.Consumer>{i18n => i18n.m.minute}</LangContext.Consumer>)
        </span>
      ),
      className: 'column-text-center',
      dataIndex: 'duration',
      key: 'duration',
      width: '10%',
      render(text, record, index) {
        return {
          children: (
            <div>
              {record.durationMinute}:{text}
            </div>
          ),
        }
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.p.parkingDateTime}
          </LangContext.Consumer>
        </span>
      ),
      className: 'column-text-center',
      dataIndex: 'startAtDate',
      key: 'startAt',
      width: '15%',
      render: (text, record) => (
        <div>
          <div>{text}</div>
          <div style={{ color: '#888', fontSize: '11px' }}>
            {record.startAtTime}
          </div>
        </div>
      ),
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.p.plantName}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'plantPunchInName',
      className: 'column-text-center',
      key: 'plantPunchInName',
      width: '20%',
      render: (text, record, index) => {
        return <label>{text == '' ? '-' : text}</label>
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>
            {i18n => i18n.s.siteNameSafetyDashboard}
          </LangContext.Consumer>
        </span>
      ),
      dataIndex: 'siteName',
      className: 'column-text-center',
      key: 'siteName',
      width: '20%',
      render: (text, record, index) => {
        return (
          <Link to={`/location/edit/${record.siteID}`}>
            {text == '' ? '-' : text}
          </Link>
        )
      },
    },
    {
      title: (
        <span style={{ fontSize: '13px' }}>
          <LangContext.Consumer>{i18n => i18n.n.note}</LangContext.Consumer>
        </span>
      ),
      dataIndex: 'note',
      key: 'note',
      className: 'column-text-center',
      width: '10%',
      render: (text, record) => this.renderLccCauseCell(text, record),
    },
  ]

  render() {
    return (
      <div>
        <Collapse
          defaultActiveKey={['1']}
          // onChange={callback}
          expandIconPosition={'right'}
        >
          {/* จอดในจุดห้ามจอด */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#c91c1c"
                text={
                  <>
                    <LangContext.Consumer>
                      {i18n => i18n.p.parkingOnRoadSide}
                    </LangContext.Consumer>
                  </>
                }
              />
            }
            key="1"
            extra={genExtra(
              this.props.list
                .filter(ele => ele.eventType == 3000)
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(ele => ele.eventType == 3000)
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    duration: moment
                      .utc(
                        moment(ele.endAt, 'YYYY-MM-DD HH:mm:ss').diff(
                          moment(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        ),
                      )
                      .format('ss'),
                    durationMinute: moment
                      .utc(ele.endAt, 'YYYY-MM-DD HH:mm:ss')
                      .diff(
                        moment.utc(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        'minutes',
                      ),
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    note: ele.note,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,

                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                    incident_lcc_status: ele.incident_lcc_status,
                    is_lcc_enable: ele.is_lcc_enable,
                    is_transporter_enable: ele.is_transporter_enable,
                    lcc_cause: ele.lcc_cause,
                    file_url: ele.file_url,
                  }
                })}
              //   dataSource={fakeData}
              columns={this.columnsTypeNormals}
              onRow={record => {
                return {
                  onClick: () => {
                    console.log(record)
                    this.onRowClick(record.id, record.lat, record.lng, true)
                  },
                }
              }}
              size="small"
              scroll={{ x: false, y: false }}
              bordered
            />

            <Modal
              visible={this.state.visibleNote}
              title={
                <LangContext.Consumer>
                  {i18n => i18n.n.noteFill}
                </LangContext.Consumer>
              }
              onCancel={e => {
                this.setState({ visibleNote: false })
              }}
              onOk={e => {
                this.handleSaveNote()
                this.setState({ visibleNote: false })
              }}
            >
              <FormItem
                label={
                  <LangContext.Consumer>
                    {i18n => i18n.d.detail}
                  </LangContext.Consumer>
                }
                required
              >
                <TextArea
                  value={this.state.tempNote}
                  onChange={e => {
                    this.setState({ tempNote: e.target.value })
                  }}
                  rows={4}
                />
              </FormItem>
            </Modal>
          </Panel>
          {/* ความเร็วเกินกำหนด */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#00BF06"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.s.speedOverLimit}
                  </LangContext.Consumer>
                }
              />
            }
            key="2"
            extra={genExtra(
              this.props.list
                .filter(ele => ele.eventType == 1001)
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(ele => ele.eventType == 1001)
                .map((ele, i) => {
                  let type = '-'
                  if (ele.alarmType == 1001001) type = 'พื้นที่ทั่วไป'
                  if (ele.alarmType == 1001002) type = 'พื้นที่ชุมชน'
                  if (ele.alarmType == 1001003) type = 'โค้งอันตราย'
                  if (ele.alarmType == 1001004) type = 'โค้งทั่วไป'
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    duration: moment
                      .utc(
                        moment(ele.endAt, 'YYYY-MM-DD HH:mm:ss').diff(
                          moment(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        ),
                      )
                      .format('ss'),
                    durationMinute: moment
                      .utc(ele.endAt, 'YYYY-MM-DD HH:mm:ss')
                      .diff(
                        moment.utc(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        'minutes',
                      ),
                    type: type,
                    maxSpeed: Math.ceil(ele.avgValue),
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    note: ele.note,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                    incident_lcc_status: ele.incident_lcc_status,
                    is_lcc_enable: ele.is_lcc_enable,
                    is_transporter_enable: ele.is_transporter_enable,
                    lcc_cause: ele.lcc_cause,
                    file_url: ele.file_url,
                  }
                })}
              //   dataSource={fakeData}
              columns={this.columnsTypeSpeed}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
            <Modal
              visible={this.state.visibleNoteSpeedOverlimite}
              title={
                <LangContext.Consumer>
                  {i18n => i18n.n.noteFill}
                </LangContext.Consumer>
              }
              onCancel={e => {
                this.setState({ visibleNoteSpeedOverlimite: false })
              }}
              onOk={e => {
                this.handleSaveNote()
                this.setState({ visibleNoteSpeedOverlimite: false })
              }}
            >
              <FormItem
                label={
                  <LangContext.Consumer>
                    {i18n => i18n.d.detail}
                  </LangContext.Consumer>
                }
                required
              >
                <TextArea
                  value={this.state.tempNote}
                  onChange={e => {
                    this.setState({ tempNote: e.target.value })
                  }}
                  rows={4}
                />
              </FormItem>
            </Modal>
          </Panel>
          {/* ADAS */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#108ee9"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.a.adasEvent}
                  </LangContext.Consumer>
                }
              />
            }
            key="7"
            extra={genExtra(
              this.props.list
                .filter(ele => ele.eventType == 7029 && ele.category == 'ADAS')
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(ele => ele.eventType == 7029 && ele.category == 'ADAS')
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    alarmType: ele.alarmType,
                    category: ele.category,
                    videoUrl: ele.videoUrl,
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                    note: ele.note,
                    incident_lcc_status: ele.incident_lcc_status,
                    is_lcc_enable: ele.is_lcc_enable,
                    is_transporter_enable: ele.is_transporter_enable,
                    lcc_cause: ele.lcc_cause,
                    file_url: ele.file_url,
                  }
                })}
              columns={this.columnsTypeAdasDms}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* DMS */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#722ed1"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.d.dmsEvent}
                  </LangContext.Consumer>
                }
              />
            }
            key="8"
            extra={genExtra(
              this.props.list
                .filter(ele => ele.eventType == 7029 && ele.category == 'DMS')
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(ele => ele.eventType == 7029 && ele.category == 'DMS')
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    alarmType: ele.alarmType,
                    category: ele.category,
                    videoUrl: ele.videoUrl,
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                    note: ele.note,
                    incident_lcc_status: ele.incident_lcc_status,
                    is_lcc_enable: ele.is_lcc_enable,
                    is_transporter_enable: ele.is_transporter_enable,
                    lcc_cause: ele.lcc_cause,
                    file_url: ele.file_url,
                  }
                })}
              columns={this.columnsTypeAdasDms}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* AI */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#13c2c2"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.a.aiCameraEvent}
                  </LangContext.Consumer>
                }
              />
            }
            key="9"
            extra={genExtra(
              this.props.list.filter(isAiCameraEvent).length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(isAiCameraEvent)
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    alarmType: ele.alarmType,
                    category: ele.category,
                    videoUrl: ele.videoUrl,
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                    note: ele.note,
                    incident_lcc_status: ele.incident_lcc_status,
                    is_lcc_enable: ele.is_lcc_enable,
                    is_transporter_enable: ele.is_transporter_enable,
                    lcc_cause: ele.lcc_cause,
                    file_url: ele.file_url,
                  }
                })}
              columns={this.columnsTypeAdasDms}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* DA */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#faad14"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.d.deviceAbnormalEvent}
                  </LangContext.Consumer>
                }
              />
            }
            key="10"
            extra={genExtra(
              this.props.list
                .filter(
                  ele =>
                    ele.eventType == 7035 ||
                    ele.eventType == 7036 ||
                    ele.eventType == 7037,
                )
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(
                  ele =>
                    ele.eventType == 7035 ||
                    ele.eventType == 7036 ||
                    ele.eventType == 7037,
                )
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    alarmType: ele.alarmType,
                    category: ele.category,
                    videoUrl: ele.videoUrl,
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                    eventType: ele.eventType,
                  }
                })}
              columns={this.columnsTypeDA}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* ขับต่อเนื่องมากกว่า 4 ชม */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#ffd619"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.d.driveContinuouslyForMoreThan4Hours}
                  </LangContext.Consumer>
                }
              />
            }
            key="3"
            extra={genExtra(
              this.props.list
                .filter(
                  ele => ele.eventType == 7002 && ele.alarmType == 'Continuous',
                )
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(
                  ele => ele.eventType == 7002 && ele.alarmType == 'Continuous',
                )
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    duration: moment
                      .utc(
                        moment(ele.endAt, 'YYYY-MM-DD HH:mm:ss').diff(
                          moment(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        ),
                      )
                      .format('ss'),
                    durationMinute: moment
                      .utc(ele.endAt, 'YYYY-MM-DD HH:mm:ss')
                      .diff(
                        moment.utc(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        'minutes',
                      ),
                    maxSpeed: '-',
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                  }
                })}
              columns={columnsTypeNormal}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* ปฎิบัติงานมากกว่า 10 ชมต่อวัน */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="#848484"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.d.driveContinuouslyForMoreThan10HoursDay}
                  </LangContext.Consumer>
                }
              />
            }
            key="4"
            extra={genExtra(
              this.props.list
                .filter(
                  ele => ele.eventType == 7002 && ele.alarmType == 'Accumulate',
                )
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(
                  ele => ele.eventType == 7002 && ele.alarmType == 'Accumulate',
                )
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    duration: moment
                      .utc(
                        moment(ele.endAt, 'YYYY-MM-DD HH:mm:ss').diff(
                          moment(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        ),
                      )
                      .format('ss'),
                    durationMinute: moment
                      .utc(ele.endAt, 'YYYY-MM-DD HH:mm:ss')
                      .diff(
                        moment.utc(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        'minutes',
                      ),

                    maxSpeed: '-',
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                  }
                })}
              columns={columnsTypeNormal}
              size="small"
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
          {/* ออกตัวกระชาก และเบรคกระทันหัน */}
          <Panel
            header={
              <Badge
                className="safety-badge-text"
                color="purple"
                text={
                  <LangContext.Consumer>
                    {i18n => i18n.a.aggressiveAccelerationAndImmediatelyBreak}
                  </LangContext.Consumer>
                }
              />
            }
            key="6"
            extra={genExtra(
              this.props.list
                .filter(ele => ele.eventType == 1002 || ele.eventType == 2050)
                .length.toLocaleString(),
            )}
          >
            <Table
              rowKey={(record, i) => record.key + '_' + i}
              rowClassName={(record, index) =>
                record.id === this.state.selectedRow ? 'highlight-row' : ''
              }
              className="tracking-table"
              dataSource={this.props.list
                .filter(ele => ele.eventType == 1002 || ele.eventType == 2050)
                .map((ele, i) => {
                  return {
                    plate_no: ele.plateNo,
                    vehicleCode: ele.vehicleCode,
                    duration: moment
                      .utc(
                        moment(ele.endAt, 'YYYY-MM-DD HH:mm:ss').diff(
                          moment(ele.startAt, 'YYYY-MM-DD HH:mm:ss'),
                        ),
                      )
                      .format('ss'),
                    maxSpeed: '-',
                    startAtDate: moment(ele.startAt).format('DD/MM/YYYY'),
                    startAtTime: moment(ele.startAt).format('HH:mm:ss'),
                    partner: ele.partner,
                    lat: ele.startLat,
                    lng: ele.startLng,
                    id: ele._id,
                    plantPunchInCode: ele.plantPunchInCode,
                    plantPunchInID: ele.plantPunchInID,
                    plantPunchInName: ele.plantPunchInName,
                    siteCode: ele.siteCode,
                    siteID: ele.siteID,
                    siteName: ele.siteName,
                  }
                })}
              columns={columnsTypeNormal2}
              onRow={record => {
                return {
                  onClick: () => {
                    this.onRowClick(record.id, record.lat, record.lng)
                  },
                }
              }}
              scroll={{ x: false, y: false }}
              bordered
            />
          </Panel>
        </Collapse>

        <LccCauseModal
          visible={this.state.visibleLccCause}
          record={this.state.lccRecord}
          token={this.props.token}
          auth={this.props.auth}
          onCancel={this.handleCloseLccCause}
          onOk={this.handleSaveLccCause}
        />

        <LccCauseDetailModal
          visible={this.state.visibleLccCauseDetail}
          record={this.state.lccDetailRecord}
          onCancel={this.handleCloseLccCauseDetail}
        />

        <Modal
          visible={this.state.visibleVideoModal}
          title={
            <LangContext.Consumer>
              {i18n => i18n.v.viewVideo}
            </LangContext.Consumer>
          }
          footer={null}
          width={720}
          destroyOnClose
          onCancel={this.handleCloseVideoModal}
        >
          {this.state.videoModalUrl && (
            <video
              controls
              autoPlay
              style={{ width: '100%' }}
              src={this.state.videoModalUrl}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default ExpandableTable
